import moment from "moment";
import { InputLabel } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";

import { isFilterApplied } from "views/pages/manage/edpOps/constant/batch-search";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import CustomDatePicker from "views/pages/manage/common/commonComponents/CustomDatePicker";

import { InputLabelStyle, getValueById } from "./constants";

const PincodeFilters = ({
  closeForm,
  applyFilters,
  payload,
  filterCount,
  setFilterCount,
  countryList,
  stateList,
  updateStateOptions,
  districtList,
  updateDistrictOptions,
  cityList,
  updateCityOptions,
}) => {
  const DEFAULT_STATE = {
    countryId: "",
    stateId: "",
    districtId: "",
    cityId: "",
    effectiveDate: "",
  };

  const [filters, setFilters] = useState(DEFAULT_STATE);

  useEffect(() => {
    setFilters({
      countryId: payload.countryId,
      stateId: payload.stateId,
      districtId: payload.districtId,
      cityId: payload.cityId,
      effectiveDate: payload.effectiveDate,
    });
  }, [filterCount]);

  const { countryId, stateId, districtId, cityId, effectiveDate } = filters;

  useEffect(() => {
    if (countryId) updateStateOptions(countryId);
    // if (payload.stateId) {
    //   setFilters({ ...filters, state: payload.stateId });
    // }
  }, [countryId]);

  useEffect(() => {
    if (stateId) updateDistrictOptions(stateId);
  }, [stateId]);

  useEffect(() => {
    if (districtId) updateCityOptions(districtId);
  }, [districtId]);

  const filterFormHandler = (value, key) => {
    setFilters((prev) => ({ ...prev, [key]: value ?? [] }));
  };

  const handleApplyFilter = () => {
    closeForm();

    const filterCount = isFilterApplied({
      ...filters,
    });
    setFilterCount(filterCount);

    const newFilters = {
      ...filters,
      ...(effectiveDate && {
        effectiveDate: new Date(
          moment(effectiveDate).endOf("day")
        ).toISOString(),
      }),
    };

    applyFilters(newFilters);
  };

  const resetFilterForm = () => {
    closeForm();
    setFilters(DEFAULT_STATE);
    applyFilters(DEFAULT_STATE);

    setFilterCount(0);
  };

  return (
    <Card
      className="mb-0 regular-body label-color"
      style={{ width: "330px", borderRadius: "12px" }}
    >
      <CardBody className="d-flex flex-column">
        <div className="text-bold text-lg mb-2">Filters</div>

        <div className="d-flex flex-column gap-md">
          <AAutoComplete
            label="Country"
            placeholder="Select"
            items={countryList}
            currentValue={getValueById(countryList, countryId)}
            isShowCount={false}
            isMulti={false}
            handleChange={(value) => {
              filterFormHandler(value?.value, "countryId");
            }}
            inputKey="country"
          />
          <AAutoComplete
            label="State"
            placeholder="Select"
            items={stateList}
            currentValue={stateId ? getValueById(stateList, stateId) : ""}
            isShowCount={false}
            isMulti={false}
            handleChange={(value) => {
              filterFormHandler(value?.value, "stateId");
            }}
            inputKey="state"
            isDisabled={!countryId}
          />
          <AAutoComplete
            label="District"
            placeholder="Select"
            items={districtList}
            currentValue={getValueById(districtList, districtId)}
            isShowCount={false}
            isMulti={false}
            handleChange={(value) => {
              filterFormHandler(value?.value, "districtId");
            }}
            inputKey="district"
            isDisabled={!stateId}
          />
          <AAutoComplete
            label="City"
            placeholder="Select"
            items={cityList}
            currentValue={getValueById(cityList, cityId)}
            isShowCount={false}
            isMulti={false}
            handleChange={(value) => {
              filterFormHandler(value?.value, "cityId");
            }}
            inputKey="city"
            isDisabled={!districtId}
          />

          <InputLabel style={InputLabelStyle}>Effective Date</InputLabel>
          <CustomDatePicker
            placeHolder="Select"
            value={effectiveDate ? moment(effectiveDate) : null}
            handler={(index, date, keyName) => {
              filterFormHandler(date, "effectiveDate");
            }}
            // minDate={moment(startDate)}
            maxDate={moment().startOf("day")}
            // disabled={!startDate}
          />

          <div className="mt-3 d-flex flex-row-reverse">
            <AButton
              variant="primary_filled"
              className="w-full"
              onClick={handleApplyFilter}
              disabled={
                !countryId &&
                !stateId &&
                !districtId &&
                !cityId &&
                !effectiveDate
              }
            >
              Apply filter
            </AButton>

            {filterCount > 0 && (
              <AButton
                variant="outline"
                className="button_remove_left_margin"
                updatedStyle={{ border: "1px solid #CC5F5F", color: "#CC5F5F" }}
                onClick={resetFilterForm}
              >
                Reset
              </AButton>
            )}
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default PincodeFilters;
